module.exports = __webpack_public_path__ + "img/online-support.dbe96c9e.png";